export enum ESignInStep {
  Phone = 'phone',
  Code = 'code',
  FillingProfile = 'fillingProfile',
  Blocked = 'blocked',
}